"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import MoneyClient from "../../../../components/MoneyClient";
import { normalizeCurrency, toCents } from "@lib/currency";
import { STORE_BASE_CURRENCY } from "@lib/config";
import { capitalizeFirstLetter } from "@lib/util/text";
import { resolveProductHref } from "@lib/util/product-route";
type Product = {
  id?: string;
  _id?: string;
  slug: string;
  name: string;
  thumbnail?: string;
  videoUrl?: string | null;
  images?: Array<{
    url?: string | null;
  }>;
  brand?: {
    name?: string;
    slug?: string;
  };
  price?: number;
  originalPrice?: number;
  discountedPrice?: number | null;
  currency?: string;
};
type ProductHeroBannerProps = {
  products: Product[];
};
export default function ProductHeroBanner(t0) {
  const $ = _c(6);
  const {
    products
  } = t0;
  if (!products || products.length === 0) {
    return null;
  }
  const renderProductCard = _temp;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== products) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = (product_0, index_0) => <SwiperSlide key={product_0.id || product_0._id || product_0.slug}>{renderProductCard(product_0, index_0)}</SwiperSlide>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    t2 = products.map(t3);
    $[1] = products;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <section className="relative w-full"><Swiper slidesPerView={1} slidesPerGroup={1} spaceBetween={0} breakpoints={t1}>{t2}</Swiper></section>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(product, index) {
  const productRoute = resolveProductHref(product);
  const displayProductName = capitalizeFirstLetter(product.name);
  const imageUrl = product.thumbnail || (product.images && product.images.length > 0 ? product.images[0]?.url : null) || null;
  const videoUrl = !imageUrl ? product.videoUrl ?? null : null;
  const originalPrice = typeof product.originalPrice === "number" ? product.originalPrice : product.price || 0;
  const discountedPrice = typeof product.discountedPrice === "number" ? product.discountedPrice : null;
  const hasDiscount = discountedPrice !== null && discountedPrice > 0 && discountedPrice < originalPrice;
  const finalPrice = hasDiscount ? discountedPrice : originalPrice;
  const productCurrency = normalizeCurrency(product.currency || STORE_BASE_CURRENCY, STORE_BASE_CURRENCY);
  return <Link href={productRoute} className="relative block h-[45vh] min-h-[450px] md:h-[95vh] md:min-h-[850px] overflow-hidden group" key={product.id || product._id || product.slug}><div className="absolute  inset-0 bg-neutral-100">{imageUrl ? <Image src={imageUrl} alt={displayProductName || product.name} fill={true} priority={index < 2} loading={index < 2 ? "eager" : "lazy"} sizes="(max-width: 768px) 100vw, 50vw" className="object-cover object-center transition-transform duration-700 group-hover:scale-105]" /> : videoUrl ? <video className="h-full w-full object-cover" src={videoUrl} muted={true} playsInline={true} autoPlay={true} loop={true} /> : <div className="h-full w-full bg-gray-100" />}</div><div className="absolute bg-gradient-to-t from-black/20 via-transparent to-transparent" /><div className="absolute bottom-0 bg-black px-6 py-5 min-w-[300px] w-full"><div className="flex flex-col">{product.brand?.name && <p className="text-xs font-lealti uppercase text-white">{product.brand.name} | TIENDA OFICIAL</p>}<h3 className="text-lg font-lealti-light text-white leading-snug max-w-[300px] line-clamp-2">{displayProductName || product.name}</h3><div className="flex items-baseline gap-3"><p className="text-lg font-lealti-light text-white"><MoneyClient amountCents={toCents(finalPrice)} fromCurrency={productCurrency} /></p>{hasDiscount && originalPrice && <p className="text-sm font-lealti text-neutral-400 line-through"><MoneyClient amountCents={toCents(originalPrice)} fromCurrency={productCurrency} /></p>}</div></div></div></Link>;
}